export default __webpack_public_path__ + "static/media/YAS0520.34I-27808_-16709_0.466e5290.jpg";